require('datatables-bootstrap');

var $formSearchTableData = $('form#form-search');
var searchTableDataDefault = (function ($) {

    var $dataTable;
    var $orders = [];
    var params = {};

    return {
        init: function () {
            $fields = this.getTable().find('thead tr th').map(function (index, element) {
                if ($(element).data('order'))
                    $orders.push([index, $(element).data('order')]);

                return {
                    'data': $(element).data('field'),
                    "orderable": $(element).data('orderable') || false
                };
            });

            $dataTable = this.getTable().DataTable({
                processing: true,
                serverSide: true,
                searching: false,
                ajax: {
                    url: this.getTable().data('url'),
                    data: this.getParams
                },
                columns: $fields,
                order: $orders,
                language: {
                    "sProcessing": "A processar...",
                    "sLengthMenu": "Mostrar _MENU_ registos",
                    "sZeroRecords": "Não foram encontrados resultados",
                    "sInfo": "Mostrando de _START_ até _END_ de _TOTAL_ registos",
                    "sInfoEmpty": "Mostrando de 0 até 0 de 0 registos",
                    "sInfoFiltered": "(filtrado de _MAX_ registos no total)",
                    "sInfoPostFix": "",
                    "sSearch": "Procurar:",
                    "sUrl": "",
                    "oPaginate": {
                        "sFirst": "Primeiro",
                        "sPrevious": "Anterior",
                        "sNext": "Seguinte",
                        "sLast": "Último"
                    }
                },
            });

            $formSearchTableData.find('button').on('click', function (event) {
                event.preventDefault();
                event.stopPropagation();
                $dataTable.ajax.reload();
            });
        },
        getTable: function () {
            return $('table.datatable');
        },
        getParams: function (data) {

            var formdata = $formSearchTableData.serializeArray();

            params['draw'] = data.draw;
            params['start'] = data.start;
            params['length'] = data.length;
            params['order'] = [];

            for (var order of data.order) {
                params['order'].push({
                    column: data.columns[order.column].data,
                    dir: order.dir
                });
            }

            $(formdata).each(function (idx, row) {
                params[row.name] = row.value;
            });

            return params;
        }
    };
})($);

if ($formSearchTableData.length) {
    searchTableDataDefault.init();
}


// WEBPACK FOOTER //
// ./resources/assets/admin/js/scripts/script-datatable.js